import "./Home.module.css";
import WildlingsWestHeader from "@/reusable_sections/Header";
import WesternVistasHero from "./sections/WesternVistasHero";
import TravelLog from "./sections/TravelLog";
import RecentDustTracks from "./sections/RecentDustTracks";
import TheRig from "./sections/TheRig";
import OutBackGearReview from "./sections/OutBackGearReview";
import JoinTheConvoy from "./sections/JoinTheConvoy";
import ExpeditionFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <WildlingsWestHeader />
      <WesternVistasHero />
      <TravelLog />
      <RecentDustTracks />
      <TheRig />
      <OutBackGearReview />
      <JoinTheConvoy />
      <ExpeditionFooter />
    </div>;
}